import script from "./ScrollerHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollerHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./ScrollerHorizontal.vue?vue&type=style&index=0&id=63cae480&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cae480"]])

export default __exports__